import { Card, Empty, Segmented, Statistic } from 'antd';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import React from 'react';
import { createUseStyles } from 'react-jss';
import { CollectionServer, CollectionServerMobile, JSXMap, QueryDetail, QueryOrder, QueryParam } from 'fennec-ui';
import "react-lightbox-pack/dist/index.css";
import Icofont from 'react-icofont';
import OstatkiPoSchetu from '../../forms/OstatkiPoSchetu';
import FilterFieldLabel from '../../components/FilterFieldLabel';

dayjs.locale('ru');
var _ = require('lodash');

const useStyles = createUseStyles({
	item: {
		// padding: "5px 10px",
		display: "flex",
		cursor: "pointer",
		'&:hover': {
			backgroundColor: "#f9f9f9"
		}
	},
	block: {
		'& .buttons': {
			marginBottom: "10px"
		},
	},
	ticket: {
		padding: "5px 10px",
		'&:hover': {
			backgroundColor: "#f9f9f9"
		}
	},
	ticketHeader: {
	},
	ticketName: {

	},
	collapsePanel: {
		'& .ant-collapse-content > .ant-collapse-content-box': {
			padding: "6px"
		},
		'&.ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box': {
			paddingTop: "0px",
			paddingBottom: "0px"
		}
	}
})

function getCurrencyValue(value, color) {
	if (!value) {
		return (<span style={{ color: "grey" }}>
			{(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
		</span>)
	}
	if (color) {
		return (<span style={{ color: color }}>
			{(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
		</span>)
	}
	if (value >= 0) {
		return (<span style={{ color: "rgb(63, 134, 0)" }}>
			{(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
		</span>)
	}
	if (value < 0) {
		return (<span style={{ color: "red" }}>
			{(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
		</span>)
	}
}

export default function Account(props) {
	const classes = useStyles();
	const { auth, account } = props;

	const balance = (e) => {
		let v = _.get(e, "ostatok")
		if (v) return v;
		return 0;
	};

	const volume = balance(account);
	const [panel, setPanel] = React.useState('dvizheniya');
	const filters = () => [
		{
			label: "Дата создания",
			name: "CreatedAt",
			filterType: "range",
			// func: ["min", "max"],
			sort: true,
			filter: true,
		},
		{
			label: "Тип счета списания",
			name: "ukhod.akkauntType",
			filterType: "group",
			queryFilter: [
				QueryDetail("model"),
				QueryOrder("code", "ASC"),
				QueryParam("w-neq-id", "7")
			],
			display: (o) => o.opisanie,
			sort: true,
			filter: true,
		},
		{
			label: "Номер счета списания",
			name: "ukhod.nomerAkkaunta",
			sort: true,
			filter: true,
		},
		{
			label: "Владелец счета списания",
			name: "ukhod.accountInfo.vladelets",
			// queryComparer:"swsim", // sim, wsim, swsim
			sort: true,
			filter: true,
		},
		{
			label: "Сумма операции",
			name: "summa",
			filterType: "range",
			func: ["min", "max"],
			sort: true,
			filter: true,
		},
		{
			label: "Тип счета зачисления",
			name: "prikhod.akkauntType",
			filterType: "group",
			queryFilter: [
				QueryDetail("model"),
				QueryOrder("code", "ASC"),
				QueryParam("w-neq-id", "7")
			],
			display: (o) => o.opisanie,
			sort: true,
			filter: true,
		},
		{
			label: "Номер счета зачисления",
			name: "prikhod.nomerAkkaunta",
			sort: true,
			filter: true,
		},
		{
			label: "Владелец счета зачисления",
			name: "prikhod.accountInfo.vladelets",
			// queryComparer:"swsim", // sim, wsim, swsim
			sort: true,
			filter: true,
		},
	];

	return (<>
		<Card style={{ marginBottom: "7px" }}>

			<Statistic
				title={"Остаток по счету:"}
				value={volume}
				groupSeparator=" "
				precision={2}
				valueStyle={{ color: (volume < 0) ? '#cf1322' : '#3f8600' }}
				suffix="руб."
			/>

		</Card>

		{/* <Segmented
			defaultValue="dvizheniya"
			style={{
				marginBottom: 8,
			}}
			onChange={(value) => setPanel(value)}
			options={[
				{
					label: 'Движения денег',
					value: 'dvizheniya',
					disabled: false,
				},
				// {
				// 	label: 'Реестр остатков',
				// 	value: 'ostatki',
				// 	disabled: false,
				// },
			]}
		/> */}
		{(account && panel === "dvizheniya") &&
			<CollectionServerMobile
				noheader={true}
				auth={auth}
				name={"DvizheniyaDeneg"}
				queryDetail={"collection"}
				source={`/api/dvizheniyadeneg/byaccount/${account.ID}`}
				filters={filters}
				size={"small"}
				mode={"list"}
				customRender={(items, {
					collection,
					setCollection,
					setCollectionItem,
					removeCollectionItem,
					collectionActions,
					modelActions,
					update
				}) => (<div>
					{(items?.length <= 0) && <div><Empty description={"Нет данных"} style={{ padding: "40px 0px" }} /></div>}
					{JSXMap(items, (item, idx) => {
						return (<div key={item.ID || idx} style={{ width: "100%" }}>
							<div className={classes.item}>
								<div style={{ flex: "0 0 25px" }}>
									{(item.prikhodID == account.ID && item?.prikhodID) && <Icofont icon="caret-up" style={{ color: "green" }} />}
									{(item?.ukhodID && item.ukhodID == account.ID) && <Icofont icon="caret-down" style={{ color: "red" }} />}
									{((item.prikhodID !== account.ID && item?.prikhodID) && (item?.ukhodID && item.ukhodID !== account.ID)) && <Icofont icon="rounded-expand" rotate='90' style={{ color: "grey" }} />}
								</div>
								<div style={{ flex: "1 1 auto", fontWeight: "400", fontSize: "14px" }}>
									<div>
										{(!item?.ukhodID && item?.prikhodID) && <span>
											Зачисление денежных средств {(item?.osnovanie?.ownerType == 'ekvairing') && <span>(эквайринг)</span>}
											<Icofont icon="long-arrow-right" />
											<span><span>№{item?.prikhodNomer}</span> <span style={{ color: "#6a6a6a" }}>{item?.prikhod?.accountInfo?.vladelets}</span></span>
										</span>}
										{(item?.ukhodID && !item?.prikhodID) && <span>
											<span><span>№{item?.ukhodNomer}</span> <span style={{ color: "#6a6a6a" }}>{item?.ukhod?.accountInfo?.vladelets}</span></span>
											<Icofont icon="long-arrow-right" />
											Вывод денежных средств
										</span>}

										{(item?.ukhodID && item?.prikhodID) && <span>
											<span><span>№{item?.ukhodNomer}</span> <span style={{ color: "#6a6a6a" }}>{item?.ukhod?.accountInfo?.vladelets}</span></span>
											<Icofont icon="long-arrow-right" />
											<span><span>№{item?.prikhodNomer}</span> <span style={{ color: "#6a6a6a" }}>{item?.prikhod?.accountInfo?.vladelets}</span></span>
										</span>}
									</div>
									<div style={{ fontWeight: "300", fontSize: "12px" }}>{item?.opisanie} </div>
								</div>
								<div style={{ flex: "0 0 auto" }}>
									<div style={{ alignSelf: "flex-start", color: "#7c7c7c", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "400", fontSize: "11px" }}>
										Сумма:
									</div>
									<div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "14px" }}>
										{(item.prikhodID == account.ID) && getCurrencyValue(item?.summa, "green")}
										{(item.ukhodID == account.ID) && getCurrencyValue(-1 * item?.summa, "red")}
										{(item.prikhodID !== account.ID && item.ukhodID !== account.ID) && getCurrencyValue(item?.summa, "black")}
									</div>
								</div>
							</div>
						</div>)
					})}
				</div>)}
			/>
		}
		{/* {(account && panel === "ostatki") && <OstatkiPoSchetu auth={auth} object={account} />} */}
	</>);
}